import axios from "axios";
import store from '../../index'

const orders = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getByTitle() {
            let response = await axios.get(`/orders_list`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getOrderBySaleNum(context, payload) {
            let response = await axios.get(`/orders_list_by_sale_num/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getByUserID() {
            let response = await axios.get(`/orders_list/${store.state.userName}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getOrderItemInfo(context, payload) {
            let response = await axios.get(`/order_item_info/${payload.product_id}/${payload.amount}/${payload.customerId}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async addOrder(context, payload) {
            let response = await axios.post(`/add_order/${payload.ecap_customer_id}/${store.state.userName}`, {
                orderList: payload.orderList,
                orderInfo: payload.orderInfo
            });
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async EditOrder(context, payload) {
            let response = await axios.post(`/update_order/${payload.ecap_customer_id}/${store.state.userName}/${payload.sale_num}`, {
                orderList: payload.orderList,
                orderInfo: payload.orderInfo
            });
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getTotalGroupCost(context, payload) {
            let response = await axios.get(`/get_total_product_group_cost/${payload}/${store.state.userName}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getCustomerSaleInfo(context, payload) {
            let response = await axios.get(`/get_customer_sale_info/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getDashboardOrder(context, payload) {
            let response = await axios.get(`/dashboard_order/${store.state.userName}/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getOrdersGoodsGroup(context, payload) {
            let response = await axios.get(`/orders_goods_group/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setSaleState(context, payload) {
            let response = await axios.get(`/update_sale_state/${payload.sale_num}/${payload.cash}/${store.state.userName}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async refreshOrderPrice(context, payload) {
            let response = await axios.get(`/refresh_order_price/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getOrderTraceLists(context, payload) {
            let response = await axios.get(`/order_trace_list/${payload.archive}/${payload.expired}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getOrderTimeLine(context, payload) {
            let response = await axios.get(`/get_order_trace/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setSaleFinalState(context, payload) {
            let response = await axios.get(`/update_sale_state_modir/${payload}/${store.state.userName}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setExiSaleState(context, payload) {
            let response = await axios.get(`/update_exi_state/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getOrderDetail(context, payload) {
            let response = await axios.get(`/orders_detail_list/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getOrderDetailByStoreID(context, payload) {
            let response = await axios.get(`/orders_detail_list_by_storeid/${payload.sale_num}/${payload.hava_num}/${payload.store_id}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getHavaDetailByStoreID(context, payload) {
            let response = await axios.get(`/hava_detail_list_by_storeid/${payload.sale_num}/${payload.hava_num}/${payload.store_id}/${payload.Sale_Kind}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getHavaDetail(context, payload) {
            let response = await axios.get(`/hava_detail_list/${payload.hava_num}/${payload.Sale_Kind}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async accept_hava(context, payload) {
            let response = await axios.get(`/accept_havanum/${payload.hava_num}/${store.state.userName}/${payload.store_id}/${payload.sale_kind}/${payload.order_num}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async add_sale_target(context, payload) {
            let response = await axios.post(`/add_sale_target`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async update_sale_target(context, payload) {
            let response = await axios.post(`/update_sale_target`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async delete_sale_target(context, payload) {
            let response = await axios.get(`/delete_sale_target/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async deleteHavaleh(context, payload) {
            let response = await axios.get(`/remittance_of_goods/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setOrderTrace(context, payload) {
            let response = await axios.post(`/set_last_order_trace`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async returnOrderStage1(context, payload) {
            let response = await axios.get(`/return_order_stage1/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async returnOrderStage2(context, payload) {
            let response = await axios.get(`/return_order_stage2/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async readVisitors(context, payload) {
            let response = await axios.get(`/read_visitor_constant/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async readAvailableVisitors() {
            let response = await axios.get(`/read_available_visitor`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async changeDrive(context, payload) {
            let response = await axios.post(`/change_driver/${payload.Sale_Num}`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async generateFactor(context, payload) {
            let response = await axios.get(`/generate_factor/1/${payload.Order_Num}/${payload.Sale_Num}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not loagetFactorsd data');
            }
        },
        async getFactorItems(context, payload) {
            let response = await axios.get(`/get_factor_details/${payload.sale_num}/${payload.sale_kind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async deleteFactor(context, payload) {
            let response = await axios.get(`/delete_factor/${payload.saleNum}/${payload.saleKind}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getFactors(context, payload) {
            let response = await axios.get(`/get_factors/${payload.cs_id}/${payload.saleKind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async SetFactorViewSaleGOffState(context, payload) {
            let response = await axios.post(`/set_factor_view_saleg_off`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async SetFactorTax(context, payload) {
            let response = await axios.post(`/set_factor_tax`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getRemainOrders() {
            let response = await axios.get(`/get_remain_orders`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getRemainOrdersDetails(context, payload) {
            let response = await axios.get(`/get_remain_orders_details/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getOrderStoreList(context, payload) {
            let response = await axios.get(`/get_goods_store_list/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getWayBillList() {
            let response = await axios.get(`/way_bill_list`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async deleteWayBillList(context, payload) {
            let response = await axios.get(`/way_bill_delete/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setWayBill(context, payload) {
            let response = await axios.post(`/way_bill_crud`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setWayBillState(context, payload) {
            let response = await axios.get(`/change_waybill_state/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async prepareOrderForRemittance(context, payload) {
            let response = await axios.get(`/prepare_remittance_order/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async IssueSale(context, payload) {
            let response = await axios.post(`/issue_sale/${payload.CsId}/${payload.orderNum}/1`, payload.items);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async IssueReturnSale(context, payload) {
            let response = await axios.post(`/issue_sale_exi_return/${payload.saleNum}/${payload.havaNum}`, payload.items);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async changeFactorItemPrice(context, payload) {
            let response = await axios.get(`/change_factor_item_price/${payload.saleNum}/1/${payload.GoodsId}/${payload.newPrice}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async returnToStage4(context, payload) {
            let response = await axios.get(`/return_to_stage4/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async receiveFactorPay(context, payload) {
            let response = await axios.post(`/receive_factor_pay/${payload.saleNum}`, {
                Sale_PayDay: payload.Sale_PayDay,
                Sale_PayDate: payload.Sale_PayDate
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getExiStoreItems(context, payload) {
            let response = await axios.get(`/get_existore_items/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async deleteFinanceDocument(context, payload) {
            let response = await axios.get(`/delete_finance_document/${payload.documentNum}/${payload.accYear}/${payload.Sale_Num}/${payload.SaleKind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getDriverList() {
            let response = await axios.get(`/get_visitor_list`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async addDriver(context, payload) {
            let response = await axios.post(`/insert_visitor`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getMyDashboard(context, payload) {
            let response = await axios.get(`/get_user_dashboard_by_date/${payload.startDate}/${payload.endDate}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getFactorInfo(context, payload) {
            let response = await axios.get(`/get_factor_info/${payload.saleNum}/${payload.saleKind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async updateOrderUser(context, payload) {
            let response = await axios.get(`/update_order_user/${payload.saleNum}/${payload.userId}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async lockOrder(context, payload) {
            let response = await axios.get(`/lock_order/${payload.saleNum}/${payload.saleKind}/${payload.lockState}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async loadFactorWithNoReturn() {
            let response = await axios.get(`/factor_list_with_no_return`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async createOrderFromBuyNum(context, payload) {
            let response = await axios.post(`/create_order_from_buy_num`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async downloadFile(context, payload) {
            let response = await axios.post(`/download_file`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async directoryList(context, payload) {
            let response = await axios.post(`/directory_list`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setSaleFactorAttachmentFlag(context, payload) {
            let response = await axios.get(`/set_sale_factor_attachment_flag/${payload.Sale_Num}/${payload.Sale_Kind}/${payload.flag}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async updateOrderCustomer(context, payload) {
            let response = await axios.get(`/update_order_customer/${payload.saleNum}/${payload.saleKind}/${payload.newId}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
    },
    getters: {}
}

export default orders;
